<template>
    <div class="container-xxl py-5">
        <!-- Kullanıcı Girişleri -->
        <div class="mb-3">
            <label for="mesaj" class="form-label fw-bold">Mesajı Girin:</label>
            <textarea id="mesaj" v-model="rawMessage" class="form-control" rows="3" />
        </div>

        <div class="mb-3">
            <label for="yer" class="form-label fw-bold">Yer Bilgisi:</label>
            <input id="yer" v-model="yer" type="text" class="form-control" />
        </div>

        <div class="mb-3">
            <label for="tarih" class="form-label fw-bold">Tarih:</label>
            <input id="tarih" v-model="tarih" type="text" class="form-control" />
        </div>

        <!-- Çıktı Alanı -->
        <div class="container my-5">
            <div ref="captureArea" class="announcement-card mx-auto">
                <div class="card radius">
                    <div class="card card-header">
                        <div class="d-flex flex-column align-items-center">
                            <img src="/img/logo.png" alt="Dernek Logosu" class="logom mb-3" />
                        </div>
                    </div>
                    <div class="card card-body">

                        <h3 class="text-center fw-bold">Önemli Duyuru</h3>
                   
                            <p v-html="rawMessage" class="message-display"></p>
                     
                        <div class="m-4">
                            <p><i class="fas fa-map-marker-alt me-2 text-danger"></i><strong>Yer : </strong> {{ yer }}
                            </p>
                            <p><i class="fas fa-calendar-alt me-2 text-primary"></i><strong>Tarih : </strong> {{ tarih
                                }}
                            </p>
                            <p><i class="fas fa-phone-alt me-2 text-success"></i><strong>İletişim : </strong>
                                <a href="tel:+905079217404">0507 921 7404</a>
                            </p>
                        </div>
                    </div>
                    <div class="card card-footer">
                        <div class="mt-3 text-center">
                            <img src="/img/logo.jpg" alt="Dernek Logosu" style="height: 80px;border-radius: 50%;"
                                class="me-2 mt-2" />
                        </div>

                        <small class="text-center text-muted fst-italic m-1">Başkent Ağrılılar Eğitim, Kültür Sosyal Yardımlaşma
                            Derneği</small>
                    </div>
                </div>
            </div>
        </div>

        <!-- Görsel İndir -->
        <div class="text-center mt-3">
            <button @click="downloadAsPng" class="btn btn-success">Görüntüyü PNG Olarak Kaydet</button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import html2canvas from 'html2canvas'

const captureArea = ref(null)
const rawMessage = ref('Genel kurul sonrası ilk toplantımızı dernek binamızda yapıyoruz. Yönetim kurulu ve çalışma grubu yöneticilerimizin mutlaka katılması önemli. Yapacağımız çalışmaları ve yol haritamızı birlikte belirleyeceğimiz bu toplantıya tüm üyelerimizi bekliyoruz.')
const tarih = ref('04.10.2025 Cumartesi 19:30')
const yer = ref('Dernek Binası (Mustafa Kemal, Ziya Gökalp Cd., 06946 Sincan/Ankara)')

const downloadAsPng = async () => {
    if (!captureArea.value) return
    const canvas = await html2canvas(captureArea.value, {
        backgroundColor: '#ffffff',
        scale: 1,
    })
    const link = document.createElement('a')
    link.download = 'duyuru.png'
    link.href = canvas.toDataURL('image/png')
    link.click()
}
</script>

<style scoped>

.logom {
    height: 80px;
}

.message-display {
    font-size: 1.2rem;
    color: #333;
    line-height: 1.6;
}
</style>
